"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLicenseSchema = exports.createLicenseSchema = exports.licenseShape = void 0;
const zod_1 = require("zod");
exports.licenseShape = {
    licensedModules: zod_1.z.array(zod_1.z.string()).min(1),
    seatCount: zod_1.z.number().int().positive(),
    expiresAt: zod_1.z.coerce.date().nullable().optional(),
};
exports.createLicenseSchema = zod_1.z.object(exports.licenseShape);
exports.updateLicenseSchema = exports.createLicenseSchema.partial();
//# sourceMappingURL=license.schema.js.map